<template>
  <div ref="googleMap"></div>
</template>

<script>
  import Map from '../../../modules/map';

  export default {
    name      : 'MapGoogle',
    components: {},
    props     : [
      'chibanLists',
      'accountId',
      'pagination',
      'pdfActive',
      'temporaryHideImages',
      'centerPoint',
      'currentLocation',
      'showConfirmDialog',
      'myMarkers',
      'measureMode',
      'showAddress',
      'multiPointMode',
      'showMultiPointConfirmDialog',
      'movingMyPointMode',
      'destinationPointMode',
    ],
    data() {
      return {
        map: null
      }
    },
    mounted   : async function () {
      this.map = await Map.init(this.$refs.googleMap, this);
      Map.setShowConfirmDialog(false);
    },
    watch     : {
      chibanLists: function () {
        Map.initChibanOverlay(this);
      },

      pdfActive: function () {
        Map.pdfActive(this.pdfActive);
      },

      temporaryHideImages: function () {
        if (this.temporaryHideImages) {
          Map.temporaryHideImages();
        } else {
          Map.initChibanOverlay(this);
        }
      },

      centerPoint: function () {
        Map.changeCenterPoint(this.centerPoint);
      },

      showConfirmDialog: function () {
        Map.setShowConfirmDialog(this.showConfirmDialog);
      },

      myMarkers: function () {
        Map.displayMyMakers(this, this.myMarkers);
      },

      measureMode: function () {
        Map.changeMeasureMode(this, this.measureMode);

        // 測定モードに入ったら右クリックした地点を始点とする
        if (this.measureMode) {
          Map.setFirstMeasureMarker(this);
        }
      },

      showAddress: function () {
        if (this.showAddress) {
          Map.showAddress(this);
        }
      },

      multiPointMode: function () {
        Map.changeMultiPointMode(this, this.multiPointMode);
        if (this.multiPointMode) {
          Map.setFirstMultiPointMarker(this);
        }
      },

      showMultiPointConfirmDialog: function () {
        if (this.showMultiPointConfirmDialog) {
          Map.getDataMultiPoint(this);
        }
      },

      currentLocation: function () {
        if (this.currentLocation) {
          Map.changeCenterPoint(this.currentLocation, true, this);
        }
      },

      movingMyPointMode: function () {
        Map.changeMovingMyPointMode(this, this.movingMyPointMode);
      },

      destinationPointMode: function () {
        Map.changeDestinationPointMode(this, this.destinationPointMode);
      },
    },
    methods   : {}
  }
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
#map_canvas div > img {
  position: absolute;
}

.gm-style div > img {
  position: absolute;
}
</style>
